import React from 'react';

export interface ReasoningLimitBannerProps {
  className?: string;
}

export function ReasoningLimitBanner({
  className = '',
}: ReasoningLimitBannerProps) {
  return (
    <div
      role='alert'
      data-testid='reasoning-limit-banner'
      data-component='banner'
      data-instance='reasoning-limit'
      className={`rounded-xl px-4 py-3 ${className}`}
      style={{ backgroundColor: 'var(--color-bg-warning-secondary)' }}
    >
      <p
        className='text-sm'
        style={{ color: 'var(--color-text-warning-primary)' }}
      >
        You've reached your organization's monthly reasoning limit. New messages
        will work again once the limit resets or your limit is increased.
      </p>
    </div>
  );
}

export default ReasoningLimitBanner;
